import { PromiseUtils } from "../../../Global/Base/Promises/PromiseUtils";
import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { Edit } from "../../UI.BaseControls/Edit";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { IDropDownMenuItem } from "./DropDownInterfaces";
import { DropDownMenuItem } from "./DropDownMenuItem";
/**
     * Položka DropDownMenu pro vložení textu
     */
export class DropDownPromptItem extends DropDownMenuItem implements IDropDownMenuItem {
    private _text: string;
    private _internalOkAction: () => any = async () => { /* Prázdná arrow funkce */ };
    private _internalCancelAction: () => any = () => { /* Prázdná arrow funkce */ };
    private _okAction: (text: string, menuItem: DropDownPromptItem) => void = async () => { /* Prázdná arrow funkce */ };
    private _cancelAction: (menuItem: DropDownPromptItem) => void = () => { /* Prázdná arrow funkce */ };
    //private parent: DropDownMenu;

    private _editElement: Edit;
    private _okButton: HTMLElement;
    private _cancelButton: HTMLElement;

    public get text(): string {
        if (this._editElement)
            this._text = this._editElement.value;
        return this._text;
    }

    public set text(value: string) {
        this._text = value;
        if (this._editElement)
            this._editElement.value = value;
    }

    public get okAction(): (text: string, menuItem: DropDownPromptItem) => void {
        return this._okAction;
    }

    public set okAction(action: (text: string, menuItem: DropDownPromptItem) => void) {
        this._okAction = action;
        if (this._okButton) {
            this._internalOkAction = async () => {
                //this.Visible = false;
                if (this._okButton.classList.contains("Disabled"))
                    return;
                await this._okAction(this.text, this);
            };
            this._okButton.addEventListener("click", this._internalOkAction);
        }
    }

    public get cancelAction(): any {
        return this._cancelAction;
    }

    public set cancelAction(action: any) {
        this._cancelAction = action;
        if (this._cancelButton) {
            this._internalCancelAction = () => {
                if (this._cancelButton.classList.contains("Disabled"))
                    return;
                // uděláno takhle, aby kontrola na zavření dropDownů proběhla před skrytím promptItemu
                // kontrola zavření je v DropDownMenu.ts v bloku kolem ř.459 "window.addEventListener("click", this.list["wclick"] = (e: MouseEvent | CustomEvent) => {..."
                PromiseUtils.delay(0).then(() => this.visible = false);
                this._cancelAction(this);
            };
            this._cancelButton.addEventListener("click", this._internalCancelAction);
        }
    }

    //public get Parent(): DropDownMenu {
    //    return this.parent;
    //}

    //public set Parent(value: DropDownMenu) {
    //    this.parent = value;
    //}

    //protected _constructor() {
    //    super._constructor();
    //}

    public setValid(): void {
        this._editElement.setValid();
    }

    public setInvalid(locKey: string): void {
        this._editElement.setInvalid(locKey);
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "prompt-item");

        this._editElement = new Edit();
        this._editElement.value = this.text;

        const buttonContainer = createElement({ classes: "buttons" });
        this._okButton = createElement({ type: "button", classes: "OKButton flat icon tool-floppy-disk btn no-caption flat" });
        Localization.addLocData(this._okButton, "GUI-565556", "title", ""); // Uložit
        this._cancelButton = createElement({ type: "button", classes: "CancelButton flat icon ui-undo-a btn no-caption flat" });
        Localization.addLocData(this._cancelButton, "GUI-33412", "title", ""); // Zrušit // Stejně jako na YNC

        buttonContainer.appendChild(this._okButton);
        buttonContainer.appendChild(this._cancelButton);

        this.appendChild(this._editElement);
        this.appendChild(buttonContainer);

        this._editElement.addEventListener("keypress", async (e: KeyboardEvent) => {
            if (e.key === "Enter")
                await this._internalOkAction();
        });
    }

    protected override _setListener(): void {
        this.registerEventListener("click", (e: MouseEvent) => {
            if (e.button === 0) {
                e.stopImmediatePropagation();
            }
        });
    }

    /**
     * Dá focus input elementu
     */
    public focusEdit(): void {
        this._editElement.focus();
    }
}

registerCustomElement("tsc-DropDownPromptItem", DropDownPromptItem);
